import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import UserForm from '@/components/users/UserForm.vue';
    import { RoleOption } from '@/types';
    import { useI18n } from 'vue-i18n';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateUser',
  setup(__props) {

    const { t } = useI18n();

    const form = useForm({
        name: '',
        email: '',
        phone: '',
        role_ids: [],
        company_ids: [],
        contact_persons: [],
        language: 'da',
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "create",
    form: _unref(form),
    route: _ctx.route('v2.users.store'),
    "query-key": [_unref(QueryKey).USERS],
    title: "users.create_txt",
    "button-text": "users.create_txt",
    "modal-size": "sm:max-w-xl",
    "success-message-translated": _unref(t)('users.create.success', { username: _unref(form).name }),
    transform: 
            (data) => ({
                ...data,
                role_ids: data.role_ids.map((role) => `${role.company_id}_${role.id}`),
            })
        
  }, {
    default: _withCtx(() => [
      _createVNode(UserForm, { form: _unref(form) }, null, 8, ["form"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key", "success-message-translated", "transform"]))
}
}

})